import { ElementType, MouseEvent } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import { 
	ExitToApp as ExitToAppIcon, 
	Settings as SettingsIcon 
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const userMenuItems = [
	{ text: 'Settings', icon: <SettingsIcon fontSize="small" /> },
	{ text: 'Sign out', icon: <ExitToAppIcon fontSize="small" /> },
];

interface UserMenuProps {
	userMenuAnchorEl: null | HTMLElement;
	handleUserMenuClose: () => void;
	signOut: () => void;
}

const UserMenu: ElementType<UserMenuProps> = ({
	userMenuAnchorEl, 
	handleUserMenuClose, 
	signOut
}) => {
	const navigate = useNavigate();

	const handleMenuItemClick = (event: MouseEvent<HTMLLIElement>) => {
		handleUserMenuClose(); // Close menu immediately for better UX
		
		const index = parseInt(event.currentTarget.getAttribute('data-key') || '0');
		switch (index) {
			case 0:
				navigate('/settings'); // Navigate to settings page
				break;
			case 1:
				signOut();
				break;
			default:
				console.log('Unknown action');
				break;
		}
	};

	return (
		<Menu
			id="user-menu"
			anchorEl={userMenuAnchorEl}
			keepMounted
			open={Boolean(userMenuAnchorEl)}
			onClose={handleUserMenuClose}
			slotProps={{
				paper: {
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
					},
				},
			}}
			transformOrigin={{ horizontal: 'right', vertical: 'top' }}
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
		>
			{userMenuItems.map((item, index) => (
				<MenuItem 
					key={index}
					onClick={handleMenuItemClick}
					data-key={index}
				>
					{item.icon}
					<Typography variant="body2" sx={{ ml: 1 }}>
						{item.text}
					</Typography>
				</MenuItem>
			))}
		</Menu>
	);
}

export default UserMenu;